module.exports = "/images/vendor/flag-icon-css/flags/1x1/sh.svg?487ef1c8b75a5950ecc12052bbc4a67c";